<template>
  <div style="width: 100%; " class="flex-container">

    <div class="main-content" ref="mainContent">
      <pdf ref="pdf" :src="pdfUrl" :page="pageNum" :rotate="pageRotate" @password="password"
        @progress="loadedRatio = $event" @page-loaded="pageLoaded($event)" @num-pages="pageTotalNum = $event" @withCredentials="false"
        @link-clicked="page = $event">
      </pdf>
    </div>

    <div class="footer" ref="footer">
      <div>
        <span>当前页数/总页数：{{ pageNum }}/{{ pageTotalNum }} |</span>
        <span style="margin-left: 10px;">进度：{{ loadedRatio }} |</span>
        <span style="margin-left: 10px;">页面加载成功: {{ curPageNum }}|</span>
      </div>
      <div class="operate" style="margin-top: 20px;">
        <el-button type="primary" icon="el-icon-refresh-left" size="mini" @click.stop="counterClock">逆时针</el-button>
        <el-button type="primary" icon="el-icon-refresh-right" size="mini" @click.stop="clock">顺时针</el-button>

        <el-button type="primary" size="mini" @click.stop="prePage">上一页</el-button>
        <el-button type="primary" size="mini" @click.stop="nextPage">下一页</el-button>
        <el-button type="primary" size="mini" @click="scaleD">放大</el-button>
        <el-button type="primary" size="mini" @click="scaleX">缩小</el-button>
      </div>
    </div>
  </div>
</template>
<script>

import pdf from "vue-pdf";

export default {
  components: {
    pdf,
  },
  props: ["pageTotalNum", "pageNum", "fileName", "pdfUrl", "fileOcrDetails", "textType","direction"],
  watch: {
    pageNum(newVal, oldVal) {
      // 当someProp变化时，这里会执行  
      this.correctTheDirection(newVal)
      // 可以在这里调用方法或者执行其他逻辑  
    }
  },
  data() {
    return {
      totalPage: 1, // 总页数
      curPage: 1,  // 当前页数
      loadedRatio: 0,// 加载进度
      curPageNum: 0, // 页面加载完成
      scale: 100,  // 放大系数 默认百分百
      pageRotate: 0,  // 旋转角度 ‘90’的倍数才有效
      inputPage: 1,
      fileOcrArr: []
    };
  },
  created() {
    this.curPage = this.pageNum
    this.totalPage = this.pageTotalNum
    this.fileOcrArr = this.fileOcrDetails
    this.correctTheDirection(this.pageNum)
  },
  methods: {

    //纠正方向
    correctTheDirection(page) {
      console.log("correctTheDirection")
      console.log(this.fileOcrArr[page - 1])
      if (this.fileOcrArr.length > 0) {
        if (page - 1 < this.fileOcrArr.length && this.fileOcrArr[page - 1].direction != undefined) {
          if (this.fileOcrArr[page - 1].direction === "0") {
            this.pageRotate = 0
          } else if (this.fileOcrArr[page - 1].direction === "1") {
            this.pageRotate = 90;
          } else if (this.fileOcrArr[page - 1].direction === "2") {
            this.pageRotate = 180;
          } else if (this.fileOcrArr[page - 1].direction === "3") {
            this.pageRotate = 270;
          }
        }
      }
    },
    //放大
    scaleD() {
      this.scale += 15;
      this.$refs.pdf.$el.style.width = parseInt(this.scale) + "%";
    },

    //缩小
    scaleX() {
      // scale 是百分百展示 不建议缩放
      if (this.scale == 100) {
        return;
      }
      this.scale += -15;
      this.$refs.pdf.$el.style.width = parseInt(this.scale) + "%";
    },
    // 切换上一页
    prePage() {
      var p = this.pageNum;
      p = p > 1 ? p - 1 : this.pageTotalNum;
      if (this.fileOcrDetails[p - 1].docName != "" && this.fileOcrDetails[p - 1].content != "") {
        this.pageNum = p;
        this.$emit('updatePageNum', p);
        this.correctTheDirection(p)
      } else {
        this.pageNum = p;
        this.prePage()
      }
      // this.pageNum = p;
      // this.$emit('updatePageNum', p);
      // this.correctTheDirection(p)

    },
    // 切换下一页
    nextPage() {
      var p = this.pageNum;
      p = p < this.pageTotalNum ? p + 1 : 1;
      console.log(this.fileOcrDetails[p - 1])
      if (this.fileOcrDetails[p - 1].docName != "" && this.fileOcrDetails[p - 1].content != "") {
        this.pageNum = p;
        this.$emit('updatePageNum', p);
        this.correctTheDirection(p)
      } else {
        this.pageNum = p;
        this.nextPage()
      }
      // this.pageNum = p;
      // this.$emit('updatePageNum', p);
      // this.correctTheDirection(p)

    },
    // 顺时针选中角度
    clock() {
      this.pageRotate += 90;
    },
    // 逆时针旋转角度
    counterClock() {
      this.pageRotate -= 90;
    },
    // pdf 有密码 则需要输入秘密
    password(updatePassword, reason) {
      updatePassword(prompt('password is "test"'));
    },
    // 页面加载成功  当前页数
    pageLoaded(e) {
      // this.$emit("current", e);
      // this.curPageNum = e;
      // console.log(this.pageNum)
    },
    changePage() {
      this.pageNum = this.inputPage;
      pageLoaded()
    },
  },


}
</script>

<style scoped>
.flex-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  /* 视口高度 */
}

.main-content {
  /* 主内容样式 */
  flex: 1;
  /* 占用剩余空间 */
  margin-top: 66px;
}

.footer {
  background-color: #fff;
  /* 背景色 */
  /* 其他样式 */
  position: fixed;
}
</style>
